import Swiper from 'swiper';
class CenteredCarousel extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.elements = {
      slides: this.querySelectorAll('.carousel-slide'),
      videos: this.querySelectorAll('video'),
      pagination: this.querySelector('.swiper-pagination'),
      nextSlide: this.querySelector('.swiper-button-next'),
      prevSlide: this.querySelector('.swiper-button-prev'),
    };
    this.swiperEl = this.querySelector('.swiper-welcome');
    const desktopSlideCount = this.getAttribute('data-slide-count-desktop') ? this.getAttribute('data-slide-count-desktop') : 4.5;
    this.desktopBreakpoint = 1024;
    let defaultBreakpoints = {
      320: {
        slidesPerView: 1.5
      },
      640: {
        slidesPerView: 2.5
      },
      768: {
        slidesPerView: 3.5,
        spaceBetween: 15,
        navigation: false
      },
      990: {
        slidesPerView: desktopSlideCount,
        pagination: false
      }
    };
    const isProductCarousel = this.classList.contains('centered-product-carousel');
    if(isProductCarousel) {
      this.desktopBreakpoint = 990;
      defaultBreakpoints = {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 0
        },
        440: {
          slidesPerView: 2.5,
        },
        660: {
          slidesPerView: 3.5
        },
         990: {
          slidesPerView: 4.5
        },
        1200: {
          slidesPerView: 5.5
        },
        1500: {
          slidesPerView: 6.5
        },
        1800: {
          slidesPerView: 7.5
        },
        2200: {
          slidesPerView: 8.5
        },
        2600: {
          slidesPerView: 9.5
        },
        3000: {
          slidesPerView: 10.5
        }
      };
    }

    this.swiperParams = {
      slidesPerView: 1,
      centeredSlides: true,
      centerInsufficientSlides: true,
      spaceBetween: 20,
      loop: true,
      autoHeight: false,
      a11y: {
        enable: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide'
      },
      breakpoints: defaultBreakpoints,
      pagination: {
        el: this.elements.pagination,
        clickable: true,
        bulletActiveClass: 'swiper-pagination-bullet-active',
        bulletClass: 'swiper-pagination-bullet',
        renderBullet: function (index, className) {
          return `<span class="${className}" role="button" aria-label="Go to slide ${index + 1}"></span>`;
        }
      },
      navigation: {
        nextEl: this.elements.nextSlide,
        prevEl: this.elements.prevSlide,
      }
    };
  }

  initSwiperSlider() {
    if (!this.swiperEl || this.swiper) return;

    const disableOnDesktop = this.hasAttribute('data-disable-on-desktop') && this.getAttribute('data-disable-on-desktop') === 'true';
    const isDesktop = window.innerWidth >= this.desktopBreakpoint;
    
    if (disableOnDesktop && isDesktop) {
      return;
    }
    
    this.swiper = new Swiper(this.swiperEl, {
      ...this.swiperParams,
      on: {
        init: () => {
          this.handleSlideChange(0);
        },
        slideChange: (swiper) => {
          this.handleSlideChange(swiper.activeIndex);
        }
      }
    });
  }

  handleSlideChange(activeIndex) {
    
    if (this.elements.videos) {
      this.elements.videos.forEach(video => {
        video.pause();
      });
    }
    
    if (!this.swiper || !this.swiper.slides) return;
    
    const activeSlide = this.swiper.slides[activeIndex];
    if (!activeSlide) return;
    
    const slideTitle = activeSlide.querySelector('.carousel-slide__product-title')?.textContent || `Slide ${activeIndex + 1}`;
    this.announceToScreenReader(`Now viewing: ${slideTitle}`);
    
    const activeVideo = activeSlide.querySelector('video');
    if (activeVideo) {
      activeVideo.currentTime = 0;
      
      if (activeVideo.hasAttribute('autoplay')) {
        activeVideo.play().catch(e => {throw new Error('Error autoplaying video:', e)});
      }
    }
    
    this.setupVideoClickHandlers();
  }
  
  setupMuteButtons() {
    const muteButtons = this.querySelectorAll('.mute-button');
    
    muteButtons.forEach(button => {
      const video = button.closest('.carousel-slide')?.querySelector('video');
      if (!video) return;
      
      this.updateMuteButtonState(button, video.muted);
      
      button.addEventListener('click', (e) => {
        e.stopPropagation();
        
        video.muted = !video.muted;
        this.updateMuteButtonState(button, video.muted);
      });
    });
  }
  
  updateMuteButtonState(button, isMuted) {
    if (isMuted) {
      button.classList.add('is-muted');
      button.classList.remove('is-unmuted');
      button.setAttribute('aria-label', 'Unmute video');
      button.innerHTML = `
        <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.90074 1.54733L4.06699 4.56478H1V9.09094H4.06699L7.90074 12.1084V1.54733Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11 8.78125L15 4.78125" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11 4.78125L15 8.78125" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
    } else {
      button.classList.add('is-unmuted');
      button.classList.remove('is-muted');
      button.setAttribute('aria-label', 'Mute video');
      button.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M11 5L6 9H2v6h4l5 4zM19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
        </svg>
      `;
    }
  }

  announceToScreenReader(message) {
    // Create an aria-live region for accessibility announcements
    let announcement = this.querySelector('.sr-announcement');
    if (!announcement) {
      announcement = document.createElement('div');
      announcement.className = 'sr-announcement';
      announcement.setAttribute('aria-live', 'polite');
      announcement.setAttribute('aria-atomic', 'true');
      announcement.style.position = 'absolute';
      announcement.style.width = '1px';
      announcement.style.height = '1px';
      announcement.style.overflow = 'hidden';
      announcement.style.clip = 'rect(0, 0, 0, 0)';
      this.appendChild(announcement);
    }
    announcement.textContent = message;
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initComponents());
    } else {
      this.initComponents();
    }

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.swiper?.slidePrev();
      } else if (e.key === 'ArrowRight') {
        this.swiper?.slideNext();
      }
    });
    
    this.debouncedResize = this._debounce(this.onResize.bind(this), 200);
    window.addEventListener('resize', this.debouncedResize);
  }

  initComponents() {
    this.initSwiperSlider();
    this.setupMuteButtons();
    this.setupVideoClickHandlers();
  }

  onResize() {
 const disableOnDesktop = this.hasAttribute('data-disable-on-desktop') && this.getAttribute('data-disable-on-desktop') === 'true';
    if (!disableOnDesktop) return;

    const isDesktop = window.innerWidth >= this.desktopBreakpoint;

    if (isDesktop && this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    } else if (!isDesktop && !this.swiper) {
      this.initSwiperSlider();
    }
  }

  _debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.debouncedResize);
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
  
  setupVideoClickHandlers() {
    // Setup click handlers for all videos
    const videos = this.querySelectorAll('video');
    videos.forEach(video => {
      const videoContainer = video.closest('.video-container');
      const slide = video.closest('.carousel-slide');
      
      if (videoContainer && slide) {
        // Remove any existing click handlers
        videoContainer.onclick = null;
        
        // Add new click handler for play/pause toggle
        videoContainer.onclick = (e) => {
          // Don't trigger if clicking on mute button or its children (SVG, path, etc.)
          const muteButton = videoContainer.querySelector('.mute-button');
          if (muteButton && (muteButton === e.target || muteButton.contains(e.target))) {
            return;
          }
          
          // Check if this slide is active before allowing play/pause
          const isActiveSlide = slide.classList.contains('swiper-slide-active');
          if (!isActiveSlide) {
            // If not active, don't allow click interaction
            return;
          }
          
          if (video.paused) {
            video.play().catch(e => {throw new Error('Error playing video:', e)});
          } else {
            video.pause();
          }
        };
      }
    });
  }
}
  
    customElements.define('centered-carousel', CenteredCarousel);